import React from 'react';
interface ExpandVideoIconProps extends React.SVGProps<SVGSVGElement> {
	fill?: string;
	width?: number;
	height?: number;
}

export function ExpandVideoIcon({
	width = 16,
	height = 16,
	fill = 'currentColor',
	...props
}: Readonly<ExpandVideoIconProps>) {
	return (
		<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_857_42105)" fill={fill}>
				<path d="M19.4 9.95V4.5H4.5v14.9h5.278a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75V3.75A.75.75 0 013.75 3h16.4a.75.75 0 01.75.75v6.2a.75.75 0 01-1.5 0z" />
				<path d="M19.45 13.45h-6v6h6v-6zm1.5 6a1.5 1.5 0 01-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-6a1.5 1.5 0 011.5-1.5h6a1.5 1.5 0 011.5 1.5v6zM6 9.75v-3A.75.75 0 016.75 6h3a.75.75 0 010 1.5H8.623l2.912 2.915A.75.75 0 1110.5 11.5l-3-2.999V9.75a.75.75 0 01-1.5 0z" />
			</g>
			<defs>
				<clipPath id="clip0_857_42105">
					<path fill={fill} d="M0 0H24V24H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
